
/**
 * Validates an email address format
 * @param email The email string to validate
 * @returns True if the email is valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
  if (!email) return true; // Empty is considered valid (for optional fields)
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

/**
 * Validates an IP address format (IPv4)
 * @param ip The IP address string to validate
 * @returns True if the IP address is valid, false otherwise
 */
export const isValidIPAddress = (ip: string): boolean => {
  if (!ip) return true; // Empty is considered valid (for optional fields)
  const ipv4Regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return ipv4Regex.test(ip);
};

/**
 * Validates a port number
 * @param port The port number string to validate
 * @returns True if the port is valid, false otherwise
 */
export const isValidPort = (port: string): boolean => {
  if (!port) return true; // Empty is considered valid (for optional fields)
  const portNum = parseInt(port, 10);
  return !isNaN(portNum) && portNum >= 0 && portNum <= 65535;
};
